import { useEffect, useRef } from 'react';

const DESTINATIONS = [
  'Kyoto',
  'Patagonia',
  'Zanzibar',
  'Lofoten',
  'Oaxaca',
  'Luang Prabang',
  'Dolomites',
  'Bali',
  'Marrakesh',
  'Queenstown',
  'Azores',
  'Wadi Rum',
];

function Row() {
  return (
    <div className="marquee-row tw-flex tw-shrink-0 tw-items-center">
      {DESTINATIONS.map(place => (
        <span
          key={place}
          className="tw-flex tw-items-center tw-whitespace-nowrap tw-font-mono tw-text-xs tw-font-medium tw-uppercase tw-tracking-[0.3em] tw-text-[#7A8780] dark:tw-text-[#7E938A]"
        >
          <span className="tw-px-6">{place}</span>
          <svg
            className="tw-h-3.5 tw-w-3.5 tw-text-primary-600/60 dark:tw-text-primary-300/50"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              fill="currentColor"
              d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
            />
          </svg>
        </span>
      ))}
    </div>
  );
}

// A slow "departure belt" of destinations between hero and itinerary.
export default function Marquee() {
  const wrapRef = useRef(null);

  // The belt animates forever — pause it while off-screen so it doesn't keep
  // the compositor busy the whole session (noticeable on Safari).
  useEffect(() => {
    const node = wrapRef.current;
    if (!node || typeof IntersectionObserver === 'undefined') return undefined;
    const observer = new IntersectionObserver(([entry]) => {
      node.classList.toggle('marquee-paused', !entry.isIntersecting);
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={wrapRef}
      aria-hidden="true"
      className="tw-relative tw-overflow-hidden tw-border-0 tw-border-y tw-border-dashed tw-border-[#D8D0BC] dark:tw-border-[#2C3F37] tw-py-4 [border-top-style:dashed] [border-bottom-style:dashed] [border-top-width:1px] [border-bottom-width:1px]"
    >
      <div className="marquee-track tw-flex tw-w-max">
        <Row />
        <Row />
      </div>
      <style jsx global>{`
        .marquee-track {
          animation: tf-marquee 48s linear infinite;
        }
        .marquee-paused .marquee-track {
          animation-play-state: paused;
        }
        @keyframes tf-marquee {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-50%);
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .marquee-track {
            animation: none;
          }
        }
      `}</style>
    </div>
  );
}
